<template>
  <div class="login-container">
    <!-- 背景装饰图案 -->
    <div class="background-patterns">
      <div class="pattern-circle circle-1"></div>
      <div class="pattern-circle circle-2"></div>
      <div class="pattern-circle circle-3"></div>
      <div class="pattern-circle circle-4"></div>
      <div class="pattern-circle circle-5"></div>
      <div class="pattern-line line-1"></div>
      <div class="pattern-line line-2"></div>
      <div class="pattern-line line-3"></div>
    </div>

    <!-- 登录表单 -->
    <div class="login-form-container">
      <!-- Logo区域 -->
      <div class="logo-section">
        <div class="logo-icon">
          <div class="logo-shape">
            <div class="droplet droplet-1"></div>
            <div class="droplet droplet-2"></div>
            <div class="droplet droplet-3"></div>
          </div>
        </div>
        <div
          style="
            font-size: 24px;
            font-weight: 600;
            color: #1e293b;
            letter-spacing: 1px;
          "
        >
          肾数医疗
        </div>
      </div>

      <!-- 登录标题 -->
      <div class="login-title">
        <h2>{{ isLogin ? "账户密码登录" : "用户注册" }}</h2>
        <div class="title-underline"></div>
      </div>

      <!-- 登录表单 -->
      <form
        class="login-form"
        @submit.prevent="isLogin ? handleLogin() : handleRegister()"
      >
        <!-- 用户名输入框 -->
        <div class="input-group">
          <div class="input-icon">
            <el-icon><User /></el-icon>
          </div>
          <input
            type="text"
            v-model="formData.username"
            placeholder="账户"
            class="form-input"
            required
          />
        </div>

        <!-- 密码输入框 -->
        <div class="input-group">
          <div class="input-icon">
            <el-icon><Lock /></el-icon>
          </div>
          <input
            type="password"
            v-model="formData.password"
            placeholder="密码"
            class="form-input"
            required
          />
        </div>

        <!-- 确认密码输入框（仅注册时显示） -->
        <div class="input-group" v-if="!isLogin">
          <div class="input-icon">
            <el-icon><Lock /></el-icon>
          </div>
          <input
            type="password"
            v-model="formData.confirmPassword"
            placeholder="确认密码"
            class="form-input"
            required
          />
        </div>

        <!-- 选项和链接 -->
        <div class="form-options" v-if="isLogin">
          <label class="checkbox-container">
            <input
              type="checkbox"
              v-model="formData.autoLogin"
              class="checkbox-input" 
            />
            <span class="checkmark"></span>
            <span class="checkbox-text">自动登录</span>
          </label>
          <!-- <a href="#" class="register-link" @click.prevent="toggleMode"
            >注册账号</a
          > -->
        </div>

        <!-- 注册时的链接 -->
        <div class="form-options" v-if="!isLogin">
          <a href="#" class="login-link" @click.prevent="toggleMode"
            >返回登录</a
          >
        </div>

        <!-- 登录/注册按钮 -->
        <button type="submit" class="login-button">
          {{ isLogin ? "登录" : "注册" }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import { authAPI } from "@/api";

const isLogin = ref(true);

const formData = reactive({
  username: "",
  password: "",
  confirmPassword: "",
  autoLogin: false,
});

const emit = defineEmits(["login-success"]);

const toggleMode = () => {
  isLogin.value = !isLogin.value;
  // 清空表单数据
  formData.username = "";
  formData.password = "";
  formData.confirmPassword = "";
  formData.autoLogin = false;
};

const handleLogin = async () => {
  if (!formData.username || !formData.password) {
    ElMessage.error("请输入账户和密码");
    return;
  }
  try {
    const response = await authAPI.login({
      username: formData.username,
      password: formData.password,
    });

    if (response.code === 0) {
      const token =
        (response.data && (response.data.token ?? response.data.accessToken)) ??
        response.token;
      if (token) {
        localStorage.setItem("token", token);

        localStorage.setItem("roles", response.data.roles[0]);
      } else {
        ElMessage.warning("登录成功，但未返回令牌");
      }

      // 保存用户信息到 localStorage
      if (response.data) {
        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            userId: response.data.userId,
            userName: response.data.userName,
            phone: response.data.phone,
            name: response.data.name,
            roles: response.data.roles,
          })
        );
      }

      // ElMessage.success('登录成功')
      emit("login-success");
    } else {
      ElMessage.error(response.msg || "登录失败");
    }
  } catch (error) {
    ElMessage.error("登录失败，请重试");
    console.error("登录错误:", error);
  }
};

const handleRegister = async () => {
  if (!formData.username || !formData.password || !formData.confirmPassword) {
    ElMessage.error("请填写完整的注册信息");
    return;
  }

  if (formData.password !== formData.confirmPassword) {
    ElMessage.error("两次输入的密码不一致");
    return;
  }

  if (formData.password.length < 6) {
    ElMessage.error("密码长度至少6位");
    return;
  }

  try {
    const response = await authAPI.register({
      userName: formData.username,
      password: formData.password,
    });

    if (response.code === 0) {
      ElMessage.success("注册成功，请登录");
      isLogin.value = true;
      formData.username = formData.username;
      formData.password = "";
      formData.confirmPassword = "";
    } else {
      ElMessage.error(response.msg || "注册失败");
    }
  } catch (error) {
    ElMessage.error("注册失败，请重试");
    console.error("注册错误:", error);
  }
};
</script>
